import { useEffect, useState } from 'react';

import {
  IAdminEventEnrollmentsStore,
  IEventEnrollment
} from '../../../../../../store/admin/eventEnrollments/store';
import { IEventDetailedRound } from '../../../../../../store/admin/eventRounds/store';
import { IAdminEventTeamsStore } from '../../../../../../store/admin/eventTeams/store';

interface IUseEventRegisteredPlayers {
  adminEventEnrollments: IAdminEventEnrollmentsStore;
  adminEventTeams: IAdminEventTeamsStore;
  eventId: string | undefined;
  round: IEventDetailedRound | undefined;
}

export const useEventRegisteredPlayers = (args: IUseEventRegisteredPlayers) => {
  const { adminEventEnrollments, adminEventTeams, eventId, round } = args;

  const [roundGroupsEnrollments, setRoundGroupsEnrollments] = useState<number[]>([]);
  const [eventRegisteredPlayers, setEventRegisteredPlayers] = useState<IEventEnrollment[]>([]);

  useEffect(() => {
    if (round) {
      const groupsEnrollments = round.groups.flatMap(group =>
        group.games.flatMap(game => game.enrollment)
      );

      setRoundGroupsEnrollments(groupsEnrollments);
    }
  }, [round]);

  useEffect(() => {
    if (adminEventEnrollments && eventId) {
      const enrollments = adminEventEnrollments[Number(eventId)] || [];

      const eventTeams = adminEventTeams[Number(eventId)] || [];
      const eventsEnrollments = eventTeams.flatMap(team => team.enrollments);

      setEventRegisteredPlayers(
        enrollments.filter(enrollment => {
          const isActive = enrollment.status === 'active';
          const isInTeeSheet = roundGroupsEnrollments.includes(enrollment.id);
          const isInATeam = eventsEnrollments.includes(enrollment.id);

          return isInTeeSheet || isActive || isInATeam;
        })
      );
    }
  }, [adminEventEnrollments, eventId, roundGroupsEnrollments, adminEventTeams]);

  return [eventRegisteredPlayers];
};
